export default {
  data () {
    return {
      editWatching: false,
      $_editingWatcher: null
    }
  },
  methods: {
    beginEditWatch (getWatcherFn, deep = true) {
      if (this.$_editingWatcher) {
        this.endEditWatch()
      }
      this.$_editingWatcher = this.$watch(
        getWatcherFn,
        (newVal, oldVal) => {
          this.editWatching = true
        },
        {
          deep: deep
        }
      )
    },
    endEditWatch () {
      this.editWatching = false
      if (this.$_editingWatcher) {
        this.$_editingWatcher()
      }
    },
    triggerSaveComfirm (ok, finale) {
      if (this.editWatching) {
        this.$confirm('是否保存改动？', '', {
          confirmButtonText: '保存',
          cancelButtonText: '不保存',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        }).then(() => {
          if (ok()) {
            finale()
          }
        }).catch(() => {
          this.endEditWatch()
          finale()
        })
      } else {
        this.endEditWatch()
        finale()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/save-confirm.js